<template id="PageNotFound">
	<div class="container">
		<div class="txt">
			<h1>Vous vous êtes égarés</h1>
			<h3>Erreur 404 - Page Not Found</h3>
		</div>	
		<div class="NotFound">
		</div>
	</div>
</template>

<script>
export default {
	name: 'PageNotFound',
	data () {
		return {}
	}
}
</script>

<style scoped>
	.container{
		min-height:90%;
		display: flex;
		justify-content:flex-end;
		align-items:center;
	}
	.NotFound{
		background-image:url(../assets/NotFound.svg);
		background-size:cover;
		background-repeat: no-repeat;
		background-position: center;
		min-height: 100%;
		width:70%;
	}

	@media all and (max-width: 1400px) {
		.container{
			display:inline-block;
			align-items:inherit;
			justify-content:inherit;
			min-height:80%;
		}
		.NotFound{
			width:100%;
			background-position: bottom;
			background-size:contain;
			min-height:inherit;
		}
		.txt{text-align: center;margin:50px 0px 50px 0px}

	}
	@media all and (max-width: 700px) {
		.NotFound{
			background-size:cover;
			background-position:bottom left;
		}
			.txt{text-align: center;margin:50px 20px 40px 20px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue